import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function EducationNotes() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Notes")}</legend>
      <input
        type="text"
        onChange={onChange}
        value={searchObject.notes || ""}
        name="notes"
        className="form-control"
      />
    </fieldset>
  );
}
